
window.theme = window.theme || {};
theme.Currency = (function () {
  var moneyFormat = $("#shop_currency_val").text();
  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ",";
      decimal = decimal || ".";
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split(".");
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  }
  return {
    formatMoney: formatMoney,
  };
})();
/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var curr = Shopify.currency.active;
var ajaxCart = (function (module, $) {
  var shop_currency = $("#shop_currency_val").text();
  ("use strict");
  var init, loadCart;
  var settings, isUpdating, $body;
  var $formContainer,
    $addToCart,
    $cartCountSelector,
    $cartCostSelector,
    $cartContainer,
    $drawerContainer;
  var updateCountPrice,
    formOverride,
    itemAddedCallback,
    itemErrorCallback,
    cartUpdateCallback,
    buildCart,
    cartCallback,
    adjustCart,
    adjustCartCallback,
    validateQty;
  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {
    settings = {
      formSelector: 'form[action^="/cart/add"]',
      cartContainer: "#cart_container_id",
      addToCartSelector: 'button[type="submit"]',
      cartCountSelector: null,
      cartCostSelector: null,
      moneyFormat: shop_currency,
      disableAjaxCart: false,
      enableQtySelectors: false,
    };
    $.extend(settings, options);
    $formContainer = $(settings.formSelector);
    $cartContainer = $(settings.cartContainer);
    $addToCart = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector = $(settings.cartCostSelector);
    $body = $("body");
    isUpdating = false;
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }
    adjustCart();
  };
  loadCart = function () {
    wc_theme_source.lib.get_cart(cartUpdateCallback);
  };
  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass("hidden-count");
      if (cart.item_count === 0) {
        $cartCountSelector.addClass("hidden-count");
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, ""));
    }
  };
  formOverride = function () {
    $formContainer.on("submit", function (evt) {
      evt.preventDefault();
      wc_theme_source.lib.addtocart_form(
        evt.target,
        itemAddedCallback,
        itemErrorCallback
      );
    });
  };
  itemAddedCallback = function (product) {
    wc_theme_source.lib.get_cart(cartUpdateCallback);
  };
  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval("(" + XMLHttpRequest.responseText + ")");
    $addToCart.removeClass("is-adding is-added");
    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after(
          '<div class="errors qty-error">' + data.description + "</div>"
        );
      }
    }
  };
  cartUpdateCallback = function (cart) {
    updateCountPrice(cart);
    buildCart(cart);
  };
  buildCart = function (cart) {
    $cartContainer.empty();
    if (cart.item_count === 0) {
      var emptycart = $(".empty_cls").html();
      $cartContainer.append(
        '<div class="amptyclscart">Your cart is currently empty.</div>'
      );
      cartCallback(cart);
      return;
    }
    var items = [],
      item = {},
      data = {},
      source = $("#CartTemplate").html(),
      template = Handlebars.compile(source);
    $.each(cart.items, function (index, cartItem) {
      if (cartItem.image != null) {
        var prodImg = cartItem.image
          .replace(/(\.[^.]*)$/, "$1")
          .replace("http:", "");
      } else {
        var prodImg =
          "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }
      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function (key, value) {
          if (key.charAt(0) === "_" || !value) {
            delete cartItem.properties[key];
          }
        });
      }
      var pro_id_cart = cartItem.product_id;
      var variants = [],
        variant_len;
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        mainname: cartItem.product_title,
        variation: cartItem.variant_title,
        type: cartItem.product_type,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, shop_currency),
        lineprice: Shopify.formatMoney(cartItem.line_price, shop_currency),
        discountedPrice: Shopify.formatMoney(
          cartItem.price - cartItem.total_discount / cartItem.quantity,
          shop_currency
        ),
        discounts: cartItem.discounts,
        discountsApplied:
          cartItem.price === cartItem.price - cartItem.total_discount
            ? false
            : true,
        vendor: cartItem.vendor,
        id: cartItem.variant_id,
        pro_id: cartItem.product_id,
        varlength: variant_len,
      };
      items.push(item);
    });
    data = {
      items: items,
      note: cart.note,
      totalitemcount: cart.item_count,
      totalPrice: Shopify.formatMoney(cart.total_price, shop_currency),
      totalCartDiscount:
        cart.total_discount === 0
          ? 0
          : "translation missing: en.cart.general.savings_html".replace(
              "[savings]",
              theme.Currency.formatMoney(
                cart.total_discount,
                settings.moneyFormat
              )
            ),
    };
    $cartContainer.append(template(data));
    cartCallback(cart);
  };
  cartCallback = function (cart) {
    $body.trigger("ajaxCart.afterCartLoad", cart);
    wc_theme_source.lib.on_cart_update(cart);
    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };
  adjustCart = function () {
    $body.on("click", ".ajaxcart__qty-adjust", function () {
      if (isUpdating) {
        return;
      }
      var $el = $(this),
        line = $el.data("line"),
        $qtySelector = $el.parents("ul.QuantityBox").find(".ajaxcart__qty-num"),
        qty = parseInt($qtySelector.val());
      var qty = validateQty(qty);
      if ($el.hasClass("ajaxcart__qty--plus")) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });
    $body.on("click", ".cart_remove_item", function () {
      var line = $(this).attr("data-line");
      wc_theme_source.lib.cart_remove_item(line, adjustCartCallback);
    });
    $body.on("change", ".ajaxcart__qty-num", function () {
      if (isUpdating) {
        return;
      }
      var $el = $(this),
        line = $el.data("line"),
        qty = parseInt($el.val().replace(/\D/g, ""));
      var qty = validateQty(qty);
      if (line) {
        updateQuantity(line, qty);
      }
    });
    $body.on("submit", "form.ajaxcart", function (evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });
    $body.on("focus", ".ajaxcart__qty-adjust", function () {
      var $el = $(this);
      setTimeout(function () {
        $el.select();
      }, 50);
    });
    function updateQuantity(line, qty) {
      isUpdating = true;
      var $row = $('.Quantity_cart_slider[data-line="' + line + '"]').addClass(
        "is-loading"
      );
      if (qty === 0) {
        $row.parent().addClass("is-removed");
      }
      setTimeout(function () {
        wc_theme_source.lib.cart_change_item(line, qty, adjustCartCallback);
      }, 250);
    }
  };
  adjustCartCallback = function (cart) {
    updateCountPrice(cart);
    setTimeout(function () {
      wc_theme_source.lib.get_cart(buildCart);
      isUpdating = false;
    }, 150);
  };
  validateQty = function (qty) {
    if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
    } else {
      qty = 1;
    }
    return qty;
  };
  module = {
    init: init,
    load: loadCart,
  };
  return module;
})(ajaxCart || {}, jQuery);
var shop_currency_default = $("#shop_currency_val").text();
var shop_currency;

var currentFormID = $("#product_form_id").attr("product_form_id");
function myCartSection() {}
jQuery(window).resize(function () {
  myCartSection();
});
if (typeof $.cookie("currency") === "undefined") {
  shop_currency = shop_currency_default;
} else {
  shop_currency = $.cookie("currency");
}
var wc_theme_source = {
  lib: {
    ajax_error: function (error, message) {
      var data = eval("(" + error.responseText + ")");
      if (!!data.message) {
        //$('#added_product_popup').find('h3').text(data.description);
      }
    },
    on_cart_update: function (item) {
      setTimeout(function () {
        $.ajax({
          url: "/cart",
          type: "GET",
          success: function (data) {
            var parsed = $.parseHTML(data);
            if ($(parsed).length > 0) {
              if (parsed != null && parsed != "" && parsed != undefined) {
                $(parsed)
                  .find(".colordivcart")
                  .each(function (e) {
                    var all_col_html = $(this).prop("outerHTML");
                    var all_col_id = $(this).attr("data-id");
                    $(".items_row").each(function (e) {
                      var eachitemid = $(this).attr("data-id");
                      if (eachitemid == all_col_id) {
                        $(this)
                          .find(".cd_color")
                          .html(
                            $(parsed)
                              .find(
                                '.colordivcart[data-id="' + eachitemid + '"]'
                              )
                              .html()
                          );
                      }
                    });
                  });
              }
            }
          },
        });
        jQuery.getJSON("/cart.js?currency=" + curr + "", function (cart) {
          $(".cartcount").html(cart.item_count);
          if (cart.item_count > 0) {
            var cart_price = Shopify.formatMoney(
              cart.total_price,
              shop_currency_default
            );
            if ($(".items_carts span").hasClass("money")) {
              $(".items_carts span").remove();
              $(".items_carts").html(
                "<span class='money'>" + cart_price + "</span>"
              );
            } else {
              $(".items_carts").html(
                "<span class='money'>" + cart_price + "</span>"
              );
            }
          } else {
            $(".items_carts span").remove();
            $(".items_carts").html("<span class='money'>$0.00</span>");
          }
          var shop_currency_default = $("#shop_currency_val").text();
          function handleResponse(response) {
            var country_code = response.country_code2;
            var country_name = response.country_name;
            var country_code2 = response.country_code3;
            var currency_rate = Shopify.currency.rate;
            var default_cu = $(".mob_currency").data("defaultcurr");
            $(".default_currencycls li").each(function (e) {
              var all_cuureny = $(this).find("button").val();
              if (response.currency.code == all_cuureny) {
                $(".currency_code").val(response.currency.code);
              } else {
                $(".currency_code").val(default_cu);
              }
            });
            $(".country_list").each(function (e) {
              var eachcountry = $(this).data("country");
              if (
                eachcountry.indexOf(country_name) != -1 ||
                eachcountry.indexOf(country_code2) != -1 ||
                eachcountry.indexOf(country_code) != -1
              ) {
                $(this).addClass("active");
              }
            });
            var shipcost = parseFloat(
              $(".country_list.active").data("ship") * currency_rate
            );
            var shipprice = parseFloat(
              $(".country_list.active").data("shipprice") * currency_rate
            );
            var carttotal = parseFloat(
              $(".country_list.active").data("carttotal")
            );
            var shipicarttotal = parseFloat(carttotal + shipcost);
            if ($(".country_list.active").length > 0) {
              if (shipcost == 0) {
                $(".shipping_cost").html("Free");
                $(".free_ship_text").show();
                $(".other_Shipping_text").html(
                  "Free Shipping to " + country_name
                );
              } else {
                if (shipprice > carttotal) {
                  var shipcost_var = Shopify.formatMoney(
                    shipcost,
                    shop_currency_default
                  );
                  $(".shipping_cost").html(shipcost_var);
                  $(".free_ship_text").hide();
                  //$('.cart_totalpricecls').html(Shopify.formatMoney(shipicarttotal, shop_currency_default))
                } else {
                  $(".free_ship_text").show();
                }
                if (shipprice > cart.total_price) {
                  var shipcost_var = Shopify.formatMoney(
                    shipcost,
                    shop_currency_default
                  );
                  var shipprice_var = Shopify.formatMoney(
                    shipprice,
                    shop_currency_default
                  );
                  if (response.country_name == "South Africa") {
                    $(".other_Shipping_text").html(
                      "shipping cost to " + country_name + " is " + shipcost_var
                    );
                  } else {
                    $(".other_Shipping_text").html(
                      "Free shipping to " +
                        country_name +
                        " over " +
                        shipprice_var
                    );
                  }
                } else {
                  $(".other_Shipping_text").html("Aligible for free shipping");
                }
              }
            } else {
              $(".shipping_cost").text($(".shipping_cost").data("checkout"));
              $(".other_Shipping_text").html(
                "Shipping Cost is Calculated at Checkout"
              );
            }
          }
          _ipgeolocation.getGeolocation(
            handleResponse,
            "0517c5a644bb465791c13c06f56d2aef"
          );
        });
      }, 100);
    },
    on_item_added: function (item) {
      //wc_theme_source.lib.on_cart_update(item);
      ajaxCart.load();
    },
    on_product: function (e) {
      console.log(
        "Received everything we ever wanted to know about " + e.title
      );
    },
    addtocart_product: function (id, qty, thidbtngrid, callback) {
      var qty = qty || 1;
      var ajax = {
        type: "POST",
        url: "/cart/add.js",
        data: "quantity=" + qty + "&id=" + id,
        dataType: "json",
        success: function (item) {
          if (typeof callback === "function") {
            callback(item, id);
          } else {
            wc_theme_source.lib.on_item_added(item);
          }
          setTimeout(function () {
            $("body").addClass("CartOpen");
          }, 500);
          if (window.location.href.indexOf("cart") > -1) {
            location.reload();
          }
        },
        error: function (XMLHttpRequest, textStatus) {
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
          console.log(XMLHttpRequest);
          $(thidbtngrid).text(XMLHttpRequest.statusText);
          setTimeout(function () {
            $(thidbtngrid).text($(thidbtngrid).data("cart"));
          }, 3000);
        },
      };
      jQuery.ajax(ajax);
    },
    get_product: function (handle, callback) {
      jQuery.getJSON("/products/" + handle + ".js", function (product, n) {
        wc_theme_source.lib.on_product(product);
      });
    },
    get_cart: function (callback) {
      var curr = Shopify.currency.active;
      jQuery.getJSON(
        "/cart.js?currency=" + curr + "",
        function (cart, textstatus) {
          console.log(cart);
          if (typeof callback === "function") {
            callback(cart);
          } else {
            wc_theme_source.lib.on_cart_update(cart);
          }
        }
      );
    },
    addtocart_form: function (form_id, callback, errorCallback) {
      if (form_id == undefined) {
        form_id = currentFormID;
      }
      var ajax = {
        type: "POST",
        url: "/cart/add.js",
        data: jQuery("#" + form_id).serialize(),
        dataType: "json",
        beforeSend: function () {
          jQuery("#" + form_id)
            .find(".cart_btn_class")
            .attr("disabled", true);
        },
        success: function (item) {
          if (typeof callback === "function") {
            callback(item, form_id);
          } else {
            wc_theme_source.lib.on_item_added(item);
          }
          jQuery("#" + form_id)
            .find(".cart_btn_class")
            .attr("disabled", false);
          setTimeout(function () {
            $("body").addClass("CartOpen");
          }, 500);
        },
        error: function (XMLHttpRequest, textStatus) {
          $(".error_cartpro").text(XMLHttpRequest.responseJSON.description);
          if (typeof errorCallback === "function") {
            errorCallback(XMLHttpRequest, textStatus);
          } else {
            wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
          }
          $(".btnpro_error").text(XMLHttpRequest.responseJSON.description);
          setTimeout(function () {
            $(".btnpro_error").empty();
          }, 3000);
        },
      };
      jQuery.ajax(ajax);
    },
    cart_change_item: function (line, qty, callback) {
      var ajax = {
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=" + qty + "&line=" + line,
        dataType: "json",
        success: function (cart) {
          if (typeof callback === "function") {
            callback(cart);
          } else {
            wc_theme_source.lib.on_cart_update(cart);
          }
        },
        error: function (XMLHttpRequest, textStatus) {
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        },
      };
      jQuery.ajax(ajax);
    },
    cart_remove_item: function (line, callback) {
      var ajax = {
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=0&line=" + line,
        dataType: "json",
        beforeSend: function () {
          jQuery(".cart_loader_cls_id").show();
        },
        success: function (cart) {
          if (typeof callback === "function") {
            callback(cart);
          } else {
            wc_theme_source.lib.on_cart_update(cart);
          }
          jQuery(".cart_loader_cls_id").hide();
        },
        error: function (XMLHttpRequest, textStatus) {
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        },
      };
      jQuery.ajax(ajax);
    },
    cart_clear_all: function () {
      var ajax = {
        type: "POST",
        url: "/cart/clear.js",
        data: "",
        dataType: "json",
        success: function (cart) {
          wc_theme_source.lib.on_cart_update(cart);
        },
        error: function (XMLHttpRequest, textStatus) {
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        },
      };
      jQuery.ajax(ajax);
    },
    update_cart_form: function (form) {
      var ajax = {
        type: "POST",
        url: "/cart/update.js",
        data: jQuery("#" + form).serialize(),
        dataType: "json",
        beforeSend: function () {
          jQuery("#" + form)
            .find(".cart_btn_class")
            .attr("disabled", true);
        },
        success: function (cart) {
          wc_theme_source.lib.on_cart_update(cart);
          jQuery("#" + form)
            .find(".cart_btn_class")
            .attr("disabled", false);
        },
        error: function (XMLHttpRequest, textStatus) {
          wc_theme_source.lib.ajax_error(XMLHttpRequest, textStatus);
        },
      };
      jQuery.ajax(ajax);
    },
  },
};
$(".product-form__submit").on("click", function (e) {
  var temp_form_id = $('.form[action="/cart/add"]').attr("id");
  // jQuery(this).closest('form').attr('id')
  wc_theme_source.lib.addtocart_form(temp_form_id);
  return false;
});
$(document).on("click", ".progridbtn", function (e) {
  var formid = $(this).data("id");
  var thisbtn = $(this).closest(".pro_gridinr").find(".progridbtn");
  wc_theme_source.lib.addtocart_product(formid, 1, thisbtn);
  return false;
});
jQuery(document).ready(function () {
  ajaxCart.load();
});
$(document).on("click", ".ajaxcart__qty-adjust", function (e) {
  $(this).closest("li").addClass("active").siblings().removeClass("active");
});
// var shop_currency_default = $('#shop_currency_val').text();
// function handleResponse(response) {
//   var country_code = response.country_code2;
//   var country_name = response.country_name;
//   var country_code2 = response.country_code3;
//   var currency_rate = Shopify.currency.rate;
//   console.log(country_name);
//   $('.country_list').each(function(e){
//     var eachcountry = $(this).data('country');
//     if(eachcountry.indexOf(country_name) != -1 || eachcountry.indexOf(country_code2) != -1 || eachcountry.indexOf(country_code) != -1){
//       $(this).addClass('active');
//     }
//   });
//   var shipcost = parseFloat(($('.country_list.active').data('ship'))*currency_rate);
//   var shipprice = parseFloat(($('.country_list.active').data('shipprice'))*currency_rate);
//   var carttotal = parseFloat($('.country_list.active').data('carttotal'));
//   var shipicarttotal = parseFloat(carttotal+shipcost);
//   if($('.country_list.active').length > 0){
//     if(shipcost==0){
//       $('.shipping_cost').html('Free');
//       $('.free_ship_text').show();
//       $('.other_Shipping_text').html('Free Shipping to '+country_name);
//     }else{
//       if(shipprice>carttotal){
//         $('.shipping_cost').html(Shopify.formatMoney(shipcost, shop_currency_default));
//         $('.free_ship_text').hide();
//         //$('.cart_totalpricecls').html(Shopify.formatMoney(shipicarttotal, shop_currency_default))
//       }else{
//         $('.free_ship_text').show();
//       }
//     }
//   }else{
//     $('.shipping_cost').text($('.shipping_cost').data('checkout'));
//     setTimeout(function() {
//       $('.other_Shipping_text').html('Calculated at Checkout');
//     }, 1000);

//   }
// }
// _ipgeolocation.getGeolocation(handleResponse, "0517c5a644bb465791c13c06f56d2aef");
$(".default_currencycls li button").on("click", function (e) {
  sessionStorage.setItem("currency_wc", "true");
});

function handleResponse1(response) {
  let currencysession = sessionStorage.getItem("currency_wc");
  var country_code = response.currency.code;
  var current_country = $(
    '.desk_currency #footer-currency-popover button[value="' +
      country_code +
      '"]'
  );
  if (!$(current_country).hasClass("active")) {
    if (currencysession != "true") {
      $(current_country).trigger("click");
    }
  }
}
_ipgeolocation.getGeolocation(
  handleResponse1,
  "0517c5a644bb465791c13c06f56d2aef"
);












